module.exports = __webpack_public_path__ + "static/media/olinda-pe.a2359b54.jpg";